import { RangeSlider } from '../../Form/RangeSlider/index.tsx';

export type VoteAverageRangeSliderProps = {
  ariaLabelledBy: string;
  disabled?: boolean;
  name: string;
  onChange: (event: Event, value: number | number[], activeThumb: number) => void;
  value: number[];
};

export const VoteAverageRangeSlider = ({
  ariaLabelledBy,
  disabled,
  name,
  onChange,
  value,
}: VoteAverageRangeSliderProps) => {
  const formatValueLabel = (val: number) => val;
  const formatAriaValueText = (val: number) => `Vote average of ${String(val)}`;

  const handleOnChange = (event: Event, val: number | number[], activeThumb: number) => {
    onChange(event, val, activeThumb);
  };

  return (
    <RangeSlider
      ariaLabelledBy={ariaLabelledBy}
      disabled={disabled}
      formatAriaValueText={formatAriaValueText}
      formatValueLabel={formatValueLabel}
      getAriaLabel={() => 'Select vote average range'}
      marks={[
        { label: '0', value: 0 },
        { label: '2', value: 2 },
        { label: '4', value: 4 },
        { label: '6', value: 6 },
        { label: '8', value: 8 },
        { label: '10', value: 10 },
      ]}
      max={10}
      min={0}
      name={name}
      onChange={handleOnChange}
      step={0.5}
      sx={{
        '.MuiSlider-markLabel': {
          color: theme => theme.palette.grey[400],
        },
        '.MuiSlider-markLabelActive': {
          color: theme => theme.palette.grey[100],
        },
        marginLeft: theme => theme.spacing(1),
        width: theme => `calc(100% - ${theme.spacing(2)})`,
      }}
      value={value}
      valueLabelDisplay="auto"
    />
  );
};
